import React from 'react';
import { useI18n } from '../../i18n/index.jsx';
import { Alert } from '../ui.jsx';
import CodeInput from './CodeInput.jsx';

// "Enter the code we sent to …" — six boxes, Verify, Resend (countdown),
// Change email.
export default function CodeStep({ flow, onResend }) {
  const { t } = useI18n();
  return (
    <form className="form" onSubmit={(e) => { e.preventDefault(); flow.verify(); }}>
      <p className="code-sent-to">{t('auth.codeSentTo')} <strong>{flow.email.trim()}</strong>{' '}
        <button type="button" className="link-btn" onClick={flow.changeEmail}>{t('auth.changeEmail')}</button>
      </p>
      <CodeInput value={flow.code} onChange={flow.setCode} onComplete={(c) => flow.verify(c)} disabled={flow.busy} />
      <p className="field-hint center">{t('auth.codeHint')}</p>
      <Alert kind="success">{flow.notice}</Alert>
      <Alert>{flow.error}</Alert>
      <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={flow.busy || flow.code.length !== 6}>
        {flow.busy ? t('common.loading') : t('auth.verifyCode')}
      </button>
      <button type="button" className="btn btn-ghost btn-block" disabled={flow.busy || flow.cooldown > 0}
        onClick={async () => { if (await onResend()) flow.setNotice(t('auth.codeResent')); }}>
        {flow.cooldown > 0 ? t('auth.resendCodeIn', { s: flow.cooldown }) : t('auth.resendCode')}
      </button>
    </form>
  );
}
